import React from 'react'
import PropTypes from 'prop-types'
import { Box, Icon } from '@deseretbook/react-ui'
import { Button } from '../../../dbWebUI'
import { VIEW_OPTIONS } from '../constants'

import './ViewOptions.css'

/**
 * A `ViewOptions` component with added filter and sort options.
 *
 * @todo Write tests for this
 * @todo Add story for this
 * @returns {function} Component
 */
const ViewOptions = ({ currentView, toggleView }) => {
  const iconProps = { width: '30px', height: '30px' }

  return (
    <>
      <div className="ViewOptionsContainer" style={{ display: 'flex', alignItems: 'center' }}>
        <Box
          alignItems="center"
          justifyContent="space-between"
          style={{
            backgroundColor: '#F0F0F0',
            borderRadius: '12px',
          }}
        >
          <Button
            aria-label="Grid View"
            title="Grid View"
            className="view-options-type"
            style={{
              backgroundColor: currentView === 'grid' ? 'white' : '#F0F0F0',
            }}
            onClick={() => {
              toggleView(VIEW_OPTIONS.grid)
            }}
          >
            <Icon
              name="grid"
              color={currentView === 'grid' ? 'black' : '#000000A6'}
              style={iconProps}
              svgProps={{
                style: iconProps,
              }}
            />
          </Button>
          <Button
            onClick={() => {
              toggleView(VIEW_OPTIONS.list)
            }}
            title="List View"
            aria-label="List View"
            className="view-options-type"
            style={{
              backgroundColor: currentView === 'list' ? 'white' : '#F0F0F0',
            }}
          >
            <Icon
              name="list"
              color={currentView === 'list' ? 'black' : '#000000A6'}
              style={iconProps}
              svgProps={iconProps}
            />
          </Button>
        </Box>
      </div>
    </>
  )
}

export default ViewOptions

ViewOptions.defaultProps = {
  currentView: VIEW_OPTIONS.grid,
  toggleView: () => {},
}

ViewOptions.propTypes = {
  /** The current media view option */
  currentView: PropTypes.string,
  /** Updates the current view method (list, grid) */
  toggleView: PropTypes.func,
}
